import { render, staticRenderFns } from "./MThanks.vue?vue&type=template&id=699284c8&"
import script from "./MThanks.vue?vue&type=script&lang=ts&"
export * from "./MThanks.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports